import agent from "../../../api/agent";
export const list = (pagerInputModel) =>
  agent.requests.post(`/Language/getPagedList`, pagerInputModel);
export const create = (Language) => agent.requests.post(`/Language/create`, Language);
export const update = (Language) => agent.requests.post(`Language/update`, Language);
